export default "__VITE_PUBLIC_ASSET__b41ce9bc__"